/**
 * RPC Config. See the guide for example.
 */
export class RxStompRPCConfig {
}
